// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"197":"67a31acc1487b0d9","259":"7b785f43498bf7f2","594":"182492c5e7ad2bf0"}[chunkId] + ".js";
};